export const RestartApp = () => {
  window.location.reload();
};
